import { createContext, useContext } from 'react';

/**
 * What the app shell (AdminLayout) lends to the pages that draw their own chrome: the Bureau and the
 * Équipe have no header (PLAN-BUREAU § 4 quater), so their sidebar opens the global search itself.
 */
export interface ShellActions {
  openSearch: () => void;
}

export const ShellContext = createContext<ShellActions>({ openSearch: () => undefined });

export const useShell = (): ShellActions => useContext(ShellContext);
